import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ShareService } from '@zp-services/share.service';
import { StateService } from '@zp-services/state.service';

export const advicePageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const stateService = inject(StateService);
  const shareService = inject(ShareService);

  if (route.queryParams['data']) {
    const success = shareService.loadAnswersFromShareLink(
      route.queryParams['data'],
    );
    if (success) {
      return true;
    } else {
      console.warn(
        "[AdvicePageGuard] Fout bij laden antwoorden via gedeelde link. Doorsturen naar home."
      );
      router.navigate(["/"]);
      return false;
    }
  }

  const nextLogicalStep = stateService.getNextStep("start");

  if (nextLogicalStep === 'advies') {
    return true;
  } else {
    console.warn(
      `[AdvicePageGuard] Niet alle stappen beantwoord. Doorsturen naar /${nextLogicalStep || ""}.`
    );
    router.navigate(["/", nextLogicalStep]);
    return false;
  }
};
